import { Dialog } from '@mui/material';
import { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { enqueueSnackbar } from '../../../../reusable-components/snackbar';
import { useDispatch, useSelector } from '../../../../redux/store';
import NewTicketForm from '../../../../components/dashboard/tickets/ticket/newTicket/NewTicketForm';
import { getFacilitiesAndUsersList, setIsAddingNewTicket } from '../../../../redux/slices/tickets';

export default function NewTicket()
{
  const dispatch = useDispatch();
  const { id } = useParams();
  const location = useLocation();

  const { facilities, ticketTypes, ticketCategories, facilityCategories, defaultFacilityId, facilityTypes } = useSelector((state) => state.tickets.data);
  const { orderById } = useSelector((state) => state.orders || {});
  const { isAddingNewTicket } = useSelector((state) => state.tickets);
  const { facilityId } = orderById[id] || {};
  const { user } = useSelector((state) => state.user);

  const [users, setUsers] = useState([{ value: `${user?.firstName} ${user?.lastName}`, id: user?.email }]);
  const [isDataLoaded, setIsDataLoaded] = useState(false);

  useEffect(() => {
    if (isAddingNewTicket) {
      dispatch(getFacilitiesAndUsersList())
        .catch(() => enqueueSnackbar('Failed to load facilities and users', { variant: 'error' }))
        .finally(() => setIsDataLoaded(true));
    }
    else setIsDataLoaded(false);
  }, [isAddingNewTicket]);

  const handleClose = () => {
    dispatch(setIsAddingNewTicket(false));
    setUsers(user ? [{ value: `${user.firstName} ${user.lastName}`, id: user.email }] : []);
  };

  return <div>
    <Dialog
      open={isAddingNewTicket}
      onClose={(event, reason) => {
        if (reason === 'backdropClick' || reason === 'escapeKeyDown') return;
        handleClose();
      }}
      fullWidth
    >
      <NewTicketForm
        setOpen={(open) => dispatch(setIsAddingNewTicket(open))}
        facilities={facilities ?? []}
        users={users ?? []}
        ticketTypes={(ticketTypes ?? []).map((type) => ({ ...type, value: type.id, label: type.name })).sort((a, b) => a.label.localeCompare(b.label))}
        ticketCategories={ticketCategories ?? []}
        facilityTypes={facilityTypes}
        facilityCategories={facilityCategories ?? []}
        facilityId={facilityId ?? defaultFacilityId ?? 0}
        orderNumber={location.pathname.includes('/orders/') ? id : null}
        ticketDataLoaded={isDataLoaded}
      />
    </Dialog>
  </div>
}
